module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('router-view', {
    attrs: {
      "topicInfo": _vm.topicInfo,
      "topicID": _vm.topicID,
      "sid": _vm.sid,
      "uid": _vm.uid,
      "bg": _vm.topicInfo.imgUrl,
      "govImage": _vm.govImage,
      "attention": _vm.attention,
      "themeColor": _vm.themeColor,
      "appName": _vm.appName
    },
    on: {
      "downApp": _vm.downApp,
      "showSwiper": _vm.showSwiper
    }
  }), _vm._v(" "), (_vm.isShowSwiper) ? _c('swiper', {
    attrs: {
      "items": _vm.pics,
      "initIndex": _vm.initIndex
    },
    on: {
      "close": _vm.closeImg
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ae11b64e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 328
// module chunks = 1